export const config = {
    headerImg: require('@/assets/images/service_support/service_support_header.png'),
    headerTitle: '引领业务重塑，实现高质量发展',
    headerDesc: '数智驱动，赋能医院智慧管理',
    contentTitle: '洞察与服务协助您高质量发展',
    contentDesc: '敬在了解您所面临的重要问题，并提供新的解决思路和视角。',
    contentBtn: '敬在医院智慧管理 · 研究与洞察',
    contentSrc: require('@/assets/images/service_support/img_help_laef.svg'),
    contentDownList: [
        {
            src: require('@/assets/images/service_support/img_information_01.png'),
            title: '上海敬在-产品手册',
        },
    ]
}
